// src/plugins/echarts-setup.js
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components'

export function setupECharts() {
  use([
    CanvasRenderer,
    LineChart,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    LegendComponent,
    DataZoomComponent
  ])
}

export const ECHARTS_COLORS = [
  '#5470C6',
  '#91CC75',
  '#FAC858',
  '#EE6666',
  '#3BA272',
  '#FC8452',
  '#9A60B4',
  '#EA7CCC',
  '#73C0DE'
]

/* ===========================
   3️⃣ Map globale key → color
=========================== */

const colorMap = new Map()
let nextColorIndex = 0

export function getColorForKey(key) {
  if (!colorMap.has(key)) {
    colorMap.set(
      key,
      ECHARTS_COLORS[nextColorIndex % ECHARTS_COLORS.length]
    )
    nextColorIndex++
  }
  return colorMap.get(key)
}